export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq5f_buy.3df5c5b2.mp3";